import { defaultSyslogServerState } from "../const";

const syslogServerAction = {
  initializeState: 'INITIALIZE_STATE',
  changeName: 'CHANGE_NAME',
  changeServer: 'CHANGE_SERVER',
  changePort: 'CHANGE_PORT',
  changeProtocol: 'CHANGE_PROTOCOL',
  changeSite: 'CHANGE_SITE'
}

const syslogServerReducer = (state, action) => {
  switch (action.type) {
    case syslogServerAction.initializeState:
      return {
        ...state,
        ...action.payload
      };
    case syslogServerAction.changeName:
      return {
        ...state,
        name: action.payload
      };
    case syslogServerAction.changeServer:
      return {
        ...state,
        server: action.payload
      };
    case syslogServerAction.changePort:
      return {
        ...state,
        port: action.payload
      };
    case syslogServerAction.changeProtocol:
      return {
        ...state,
        protocol: action.payload
      };
    case syslogServerAction.changeSite:
      return {
        ...state,
        site: action.payload
      };
    default:
      return defaultSyslogServerState;
  }
};

export default {
  defaultState: defaultSyslogServerState,
  action: syslogServerAction,
  reducer: syslogServerReducer
}